var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrivaLiteDesktop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 8,
    fill: "#FFDFFA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 25H18.01",
    stroke: "#E868C8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 8H16.5C14.143 8 12.9645 8 12.2322 8.73223C11.5 9.46447 11.5 10.643 11.5 13V23C11.5 25.357 11.5 26.5355 12.2322 27.2678C12.9645 28 14.143 28 16.5 28H19.5C21.857 28 23.0355 28 23.7678 27.2678C24.5 26.5355 24.5 25.357 24.5 23V13C24.5 10.643 24.5 9.46447 23.7678 8.73223C23.0355 8 21.857 8 19.5 8Z",
    stroke: "#E868C8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrivaLiteDesktop);
export default __webpack_public_path__ + "static/media/Triva_lite_desktop.8c369ecce3a8c0044d59852dc06f4653.svg";
export { ForwardRef as ReactComponent };